import { render, staticRenderFns } from "./performance.vue?vue&type=template&id=e4490aa6&"
import script from "./performance.vue?vue&type=script&lang=js&"
export * from "./performance.vue?vue&type=script&lang=js&"
import style0 from "./performance.vue?vue&type=style&index=0&id=e4490aa6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports